import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { TipoCondicaoEspecial, TipoCondicaoEspecialRequest } from '@/models';

@Injectable({
  providedIn: 'root',
})
export class TipoCondicaoEspecialService {
  private baseUrl = `${environment.apiUrl}/admin/tipos-condicoes-especiais`;

  constructor(private http: HttpClient) {}

  getTiposCondicoesEspeciais(): Observable<TipoCondicaoEspecial[]> {
    return this.http.get<TipoCondicaoEspecial[]>(this.baseUrl);
  }

  getTipoCondicaoEspecial(id: number): Observable<TipoCondicaoEspecial> {
    return this.http.get<TipoCondicaoEspecial>(`${this.baseUrl}/${id}`);
  }

  createTipoCondicaoEspecial(data: TipoCondicaoEspecialRequest): Observable<TipoCondicaoEspecial> {
    return this.http.post<TipoCondicaoEspecial>(this.baseUrl, data);
  }

  updateTipoCondicaoEspecial(id: number, data: TipoCondicaoEspecialRequest): Observable<TipoCondicaoEspecial> {
    return this.http.put<TipoCondicaoEspecial>(`${this.baseUrl}/${id}`, data);
  }

  deleteTipoCondicaoEspecial(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  toggleStatus(id: number, active: boolean): Observable<TipoCondicaoEspecial> {
    return this.http.patch<TipoCondicaoEspecial>(`${this.baseUrl}/${id}/toggle-status`, { active });
  }
}
